/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";

import { Modal } from "components/Modal/Modal";
import { buttonYT } from "client/views/Account/WelcomePage";
import { buttonFeedback } from "client/views/SupportUs/SupportUsPage";
import { sPubCmt, sPriCmt } from "assets/jss/views/ResStrings";

interface Props {
  ytlist: string;
  onExit: () => void;
  history: any;
}

const CommentDialogBase: React.FC<Props> = ({
  onExit,
  ytlist,
  history,
}: Props) => {
  const btnCenter = {
    display: "flex",
    justifyContent: "center",
    margin: "1rem",
  };

  const yt =
    ytlist === ""
      ? "https://www.youtube.com/channel/UC854BajR6wtQPF71z6UJcLA"
      : `https://www.youtube.com/playlist?list=${ytlist}`;
  return (
    <>
      <Modal title={"Leave a Comment"} buttons={[]} onExit={onExit}>
        <>
          {sPubCmt}
          <div style={btnCenter}>{buttonYT(true, yt, "PlayList Page")}</div>
          <>
            {sPriCmt}
            <div style={btnCenter}>
              {buttonFeedback(true, history, {
                width: "56px",
                height: "28px",
                margin: "-0.5rem 0",
              })}
            </div>
          </>
        </>
      </Modal>
    </>
  );
};

const base: any = CommentDialogBase;
export const CommentDialog: any = base;
export const CommentDialogTest = CommentDialogBase;
